import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Button, Container, ImageHero, Paper } from 'library';
import { map } from 'lodash';

import Block from '../components/blocks/Block';
import ThreeImageBlock from '../components/blocks/ThreeImageBlock/ThreeImageBlock';
import JobPostings from '../components/careers/JobPostings/JobPostings';
import PerksList from '../components/careers/PerksList/PerksList';
import ValuesBlock from '../components/careers/ValuesBlock/ValuesBlock';
import CMSContent from '../components/common/CMSContent/CMSContent';
import PullQuote from '../components/common/PullQuote/PullQuote';
import Layout from '../components/layout';

const CareersTemplate = ({ data }) => {
  const blocks = data.templateFields.blocks;
  const featuredImage = data.featuredImage?.node;
  const imagesBlockQuery = useStaticQuery(graphql`
    query CareersImageBlock {
      allWpBlock(filter: { slug: { eq: "careers-images-block" } }) {
        nodes {
          title
          blockFields {
            threeImageBlockFields {
              image {
                sourceUrl
                altText
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
          slug
        }
      }
    }
  `);

  const images = imagesBlockQuery?.allWpBlock?.nodes[0]?.blockFields?.threeImageBlockFields;

  return (
    <Layout className="Careers">
      {featuredImage && <ImageHero imageURL={featuredImage.sourceUrl} imageAlt={featuredImage.altText} />}
      <Container row justify="center" space={6}>
        <Container grid="9">
          <div>
            <CMSContent content={data.content} />
            <Button href="#job-postings">View open roles</Button>
          </div>
        </Container>
      </Container>

      <ValuesBlock />

      {images && <ThreeImageBlock images={map(images, 'image')} />}

      <Container row justify="space-between">
        <Container grid={5}>
          <Container grid={10} style={{ padding: '0px' }}>
            <PullQuote
              text="At Hometap we take pride in our homeowner centric mission and in being both great owners of our work and neighbors to our colleagues and our community. We have ambitious goals of creating a new industry, a lasting, durable company, and a place where those that share our values build their professional careers."
              name="Jeff Glass"
              title="CEO, Hometap"
            />
          </Container>
        </Container>
        <Container grid={7}>
          <PerksList />
        </Container>
      </Container>

      {blocks?.map((block, index) => (
        <Block data={block} key={index} />
      ))}

      <Paper theme="medium" pad={2} id="job-postings">
        <JobPostings />
      </Paper>
    </Layout>
  );
};

export default CareersTemplate;
